'use client'

import { ButtonLink, InputCurrency, PaymentType } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { useUserPortfolio } from '@repo/services'
import { Col, Icon, Row, Skeleton, Typography } from '@repo/ui/components'
import { useMemo } from 'react'

export const HistoryBalanceHeaderLayout = () => {
  const { t } = useTranslate()
  const { data: { data: { accounts = [] } = {} } = {}, isLoading } =
    useUserPortfolio()
  const currency = 'IRR'

  const account = useMemo(() => {
    return accounts?.find((account) => account.currency === currency)
  }, [accounts, currency])

  return (
    <Col className='gap-xs py-xs'>
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/wallet'
        startIcon={<Icon name='ArrowRightLine' size='md' />}
      >
        {t('common_back')}
      </ButtonLink>
      <Row className='justify-between gap-md'>
        {isLoading ? (
          <Row>
            <Skeleton className='w-36 h-md bg-white' />
          </Row>
        ) : (
          <>
            <Typography size='lg' weight='bold'>
              {currency === 'IRR'
                ? t('walletPage_toman_balance')
                : t('walletPage_malek_balance')}
            </Typography>
            <Row className='flex-1'>
              <PaymentType
                value={account?.availableBalance}
                numberSize='md'
                size='xs'
                inputCurrency={account?.currency as InputCurrency}
              />
            </Row>
          </>
        )}

        <ButtonLink
          href='/wallet/withdraw/online-payment'
          size='xs'
          startIcon={<Icon name='TriangleArrowUpLine' size='xs' />}
          variant='transparent'
          color='base'
          className='w-[80px]'
          width='full'
        >
          {t('walletPage_withdraw')}
        </ButtonLink>
        <ButtonLink
          href='/wallet/deposit'
          size='xs'
          startIcon={<Icon name='PlusLine' size='xs' />}
          variant='fill'
          color='base'
          className='w-[80px]'
          width='full'
        >
          {t('walletPage_deposit')}
        </ButtonLink>
      </Row>
    </Col>
  )
}
